import React, { useState, useEffect } from "react";
import { PageHeader } from "components/ui";
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import GriStandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import GriFormComponent from "components/customizedStandardsComponent/GriFormComponent";
import UploadEvidenceComponent from "components/customizedStandardsComponent/UploadEvidenceComponent";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import DownloadPostReviewGapForm from "components/customizedStandardsComponent/DownloadPostReviewGapForm";
import UploadPostReviewGapForm from "components/customizedStandardsComponent/UploadPostReviewGapForm";
import DownloadPostReviewReports from "components/customizedStandardsComponent/DownloadPostReviewReports";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import NavigationButtons from "helper/navigation/NavigationButtons";
import {
  Climate_Related_Financial_Disclosure_Form,
  Customized_PRE_QUALIFICATION_FORM_FOR_SUPPLIERS,
} from "data/forms/griFormSchema";
import { PREQUALIFICATION_CHECKLIST } from "data/standards/griStandards";
import {
  supplierAssessmentModule,
  esgRiskComplianceAssessment,
  esgScoringAndSelectionStep,
  monitoringAndImprovementStep,
  reportingAndExportStep,
} from "data/reports/relevantReports";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";
import UploadEvidenceReviewReports from "components/customizedStandardsComponent/UploadEvidenceReviewReports";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";

const SupplierAssessmentSelectModule = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });
  const [showReviewPopup, setShowReviewPopup] = useState(false);

  const steps = [
    "Select GRI Standards",
    "pre-Qualification Checklist",
    "Risk & Compliance Assessment",
    "ESG Scoring & Selection Step",
    "Monitoring & Improvement Step",
    "Supplier Pre-Qualification Form",
    "Upload GHG Data & Evidence",
    "Reporting & Export Step",
  ];

  // useEffect(() => {
  //     if (activeStep === 4 && prevStep === 3) {
  //         setShowReviewPopup(true);
  //     }
  // }, [activeStep, prevStep]);

  const handleNext = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSaveStandards = (selectedStandards) => {
    setReportData((prev) => ({
      ...prev,
      selectedStandards,
    }));
    console.log("Standards saved:", selectedStandards);
  };

  const handleClosePopup = () => {
    setShowReviewPopup(false);
  };

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(5);
    setShowReviewPopup(false);
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <DownloadReport
            key="scope-format-specification-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={supplierAssessmentModule}
            title="Supplier Assessment Scope"
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
            ReportDownloadButtonShow={false}
          />
        );
      case 1:
        return (
          <StandardsSelector
            standards={PREQUALIFICATION_CHECKLIST}
            onNext={handleNext}
            onSave={handleSaveStandards}
            title="Pre-Qualification Checklist"
            nextButtonText="Next"
            initialSelectedStandards={reportData.selectedStandards.map(
              (s) => s.id
            )}
          />
        );
      case 2:
        return (
          <DownloadReport
            key="Risk-Compliance-Assessment-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={esgRiskComplianceAssessment}
            title="ESG Risk & Compliance Assessment "
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
            ReportDownloadButtonShow={false}
          />
        );
      case 3:
        return (
          <DownloadReport
            key="ESG-Scoring-Selection-step"
            onPrevious={handleBack}
            ReportDownloadButtonShow={false}
            onNext={handleNext}
            initialItems={esgScoringAndSelectionStep}
            title="Scoring & Selection Decision"
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
          />
        );
      case 4:
        return (
          <DownloadReport
            key="monitoring-and-improvement-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={monitoringAndImprovementStep}
            title="Monitoring & Continuous Improvement"
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
            ReportDownloadButtonShow={false}
          />
        );
      case 5:
        return (
          <ReusableFormComponent
            key="form-step-2"
            {...Customized_PRE_QUALIFICATION_FORM_FOR_SUPPLIERS}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
          />
        );

      case 6:
        return (
          <UploadEvidenceComponent
            onPrevious={handleBack}
            onNext={handleNext}
            title="Upload GHG Data & Evidence"
            description="Upload your emissions data, energy consumption logs, and supporting documentation"
          />
        );

      case 7:
        return (
          <DownloadReport
            key="reporting-and-export-step"
            onPrevious={handleBack}
            // onNext={handleNext}
            initialItems={reportingAndExportStep}
            title="Download Assessments and Reports"
            description="Download and review emissions tracking guidelines and frameworks"
            stepId="step-0"
            NextButtonShow={false}
            showReportCountdownButton={true}
          />
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
          </Box>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <NavigationButtons
                imageKey="dashboardImg6_2"
                title={"Supplier Assessment & Selection Module"}
                activeStep={activeStep}
                onBack={handleBack}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {getStepContent(activeStep)}
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 4,
              mb: 2,
            }}
          ></Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: -1,
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToStep5}
      />
    </>
  );
};

export default SupplierAssessmentSelectModule;
